export const CART_SUCESS = 'CART_SUCESS';
export const GROSS_AMOUNT = 'GROSS_AMOUNT';
export const FINAL_ORDER_PRICE = 'FINAL_ORDER_PRICE';
export const COMPANY_NAME = 'COMPANY_NAME';
export const SHOP_NAME = 'SHOP_NAME';


export default {
    CART_SUCESS,
    GROSS_AMOUNT,
    FINAL_ORDER_PRICE,
    COMPANY_NAME,
    SHOP_NAME
};
